import PubSub from "underpub-js";

var RecipeSection = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-RecipeSection',
	};

	$.extend(true, this.options, options);

};

RecipeSection.prototype.init = function() {

	var self = this;

};

export default RecipeSection;
